// 목록 화면에서 상태 값을 의미색 Chip으로 표시하는 공용 프리미티브.
// 도메인별 라벨/색 매핑은 각 route가 소유한다(여기 두지 않음).

import React from "react";
import Chip from "@mui/material/Chip";
import { alpha, useTheme } from "@mui/material/styles";

export type StatusChipColor =
  | "default"
  | "primary"
  | "success"
  | "warning"
  | "error"
  | "info";

export interface StatusChipProps {
  label: string;
  color?: StatusChipColor;
  // soft: 배경 alpha + 진한 텍스트 / filled: MUI 기본 채움
  variant?: "soft" | "filled";
}

export const StatusChip: React.FC<StatusChipProps> = ({
  label,
  color = "default",
  variant = "soft",
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  if (color === "default") {
    return <Chip size="small" label={label} variant="outlined" />;
  }

  if (variant === "filled") {
    return <Chip size="small" label={label} color={color} />;
  }

  const paletteColor = theme.palette[color];
  return (
    <Chip
      size="small"
      label={label}
      sx={{
        backgroundColor: alpha(paletteColor.main, isDark ? 0.22 : 0.12),
        color: isDark ? paletteColor.light : paletteColor.dark,
        border: "none",
      }}
    />
  );
};
